import { set } from 'lodash';
import { useStore as storeZustand } from 'redux/store/StoreCached';

//* For purpose cached somethings and use outside components
class CacheService {
  constructor() {
    this.userInfo = {};
    this.optOutdomainsSupporting = [];
    this.shortLinkConditions = [];
    this.backgroundProcessEnum = {};
  }

  set(key, value) {
    set(this, key, value);
    storeZustand.getState().save(key, value);
  }
}

export default new CacheService();
